import { render, staticRenderFns } from "./SyncModal.vue?vue&type=template&id=bb4f3b7c&scoped=true&"
import script from "./SyncModal.vue?vue&type=script&lang=js&"
export * from "./SyncModal.vue?vue&type=script&lang=js&"
import style0 from "./SyncModal.vue?vue&type=style&index=0&id=bb4f3b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4f3b7c",
  null
  
)

export default component.exports